import React, { useEffect, useState } from "react";
import "./BlogsOverview.css";
import { Link } from "react-router-dom";
const BlogsOverview = () => {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    fetch(
      "https://script.google.com/macros/s/AKfycbzNePVdb8kwFqV381MKbgR7I5GZKH5Gg9nF_ypfCgizYYMouNsMpWa8eku_MuVcqWIJgA/exec"
    )
      .then((res) => res.json())
      .then((data) => {
        setBlogs(data.slice(0, 3)); 
      })
      .catch((err) => console.error("Error fetching blogs:", err));
  }, []);
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <section className="blogs-overview-section">
      <p className="blogs-overview-subtitle">
        Expert insights and latest advances in digestive care
      </p>
      <h2 className="blogs-overview-title">Stay Informed About Your Health</h2>
<div className="blogs-overview-footer">
        <Link to="/blogs" className="blogs-viewmore-btn">
          View More Blogs →
        </Link>
      </div>
      <div className="blogs-overview-grid">
        {blogs.map((blog, index) => (
          <div key={index} className="blogs-overview-card">
            <div className="blogs-overview-image">
              <img src={blog.image_url} alt={blog.title} />
              <Link to={`/blogs/${blog.id}`} className="blogs-readmore-btn">
                Read More →
              </Link>
            </div>
            <div className="blogs-overview-content">
              <h3 className="blogs-overview-heading">{blog.title}</h3>
              <p className="blogs-overview-category">{blog.date}</p>
            </div>
          </div>
        ))}
      </div>
      {/* View More Button */}
    </section>
  );
};
export default BlogsOverview;